import Vue from 'vue';
import App from './App.vue';
import axios from './axios'
import VueAxios from 'vue-axios';
import VeeValidate from 'vee-validate';
import Vuesax from 'vuesax';
import VueAuth from '@websanova/vue-auth';
import VueClipboard from 'vue-clipboard2'
import router from './router';
import store from './store/store';
import auth from './core/config/auth';
import VueExpandableImage from 'vue-expandable-image'
import globalJS from './global.js';
import bus from './eventBus';
import i18n from './i18n/i18n'
import './themeConfig.js';
import './globalComponents.js';
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'datatables.net-dt/css/jquery.dataTables.css'
import 'font-awesome/css/font-awesome.css'
import veeValidatePlugin from './plugins/veeValidate';
import AnchorPlugin from './plugins/AnchorPlugin/AnchorPlugin';
import VueTour from 'vue-tour';
import Fragment from 'vue-fragment'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import Push from 'push.js';

import 'vuesax/dist/vuesax.css';
import 'material-icons/iconfont/material-icons.css';
import '@assets/css/main.css';
import '@assets/css/iconfont.css';
import '@assets/sass/app.scss';
// import VueScrollTo from 'vue-scrollto';
// import {VueHammer} from 'vue2-hammer';
import VueSSE from 'vue-sse';


// Because same domain, so to set only pathname
axios.defaults.baseURL = `${process.env.BASE_URL}/api`; // ${process.env.MIX_APP_URL}

Vue.router = router;
App.router = Vue.router;
Vue.use(VueAxios, axios);
Vue.use(Vuesax);
Vue.use(VeeValidate);
Vue.use(VueAuth, auth);
Vue.use(VueClipboard);
Vue.use(AnchorPlugin);
Vue.use(VueTour);
Vue.use(Fragment.Plugin);
// Vue.use(VueHammer);
// Vue.use(VueScrollTo);
Vue.use(VueSSE);

veeValidatePlugin.setup();

Vue.config.productionTip = false;

window.$ = require('jquery');
window.JQuery = window.jQuery = require('jquery');

window.dt = require('datatables.net');

Vue.use(VueExpandableImage);

Vue.prototype.$site = globalJS;
Vue.prototype.$bus = bus;
Vue.prototype.$push = Push;


if (process.env.VUE_APP_HOST == 'pub.hyperlead.vn') {
  Sentry.init({
      Vue,
      dsn: "https://477bf4ecd9e24afcb4c0913721be388d@o1294831.ingest.sentry.io/6519599",
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: [process.env.VUE_APP_HOST, /^\//],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
  });
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js